import React from "react";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

/*
NOTE there is a react browser console warning coming from using Strict mode
along with Backdrop's use of Transition and Fade internally.
Eg) "findDOMNode is deprecated in StrictMode...".
A solution is to use something else instead of Backdrop here.
*/
function LoadingBackdrop(props) {
  const classes = useStyles();
  return (
    <Backdrop className={classes.backdrop} open={props.open}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}

export default LoadingBackdrop;
